<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text"><span><a href="#/xhtml/Authornote"><i>Author’s Note</i></a></span></p>
<p class="toc-text"><span><a href="#/xhtml/Prologue"><i>Prologue</i></a></span></p>
<p class="toc-text1"><span><a href="#/xhtml/chapter001">I. First Lessons</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter002">II. The Fledgling</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter003">III. Baptism of Blood</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">IV. New Skills</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">V. The Jungles Again</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">VI. The Student Who Spoke His Mind</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">VII. Return of the Tiger</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">VIII. A Changed Man</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">IX. Dress Rehearsal</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">X. A War Within a War</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample">XI. Winning the War at Home</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample">XII. Cape Gloucester</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample">XIII. Written in Blood</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample">XIV. Years of Peace</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample">XV. War on a Shoestring</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample">XVI. MacArthur’s Triumph</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter017" title="Link target outside of Sample">XVII. The Hordes of China</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter018" title="Link target outside of Sample">XVIII. End of a Nightmare</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter019" title="Link target outside of Sample">XIX. Are These Americans?</span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/Epilogue" title="Link target outside of Sample"><i>Epilogue</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/Appendix" title="Link target outside of Sample"><i>Appendix</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/index" title="Link target outside of Sample"><i>Index</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/Acknowledgments" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/author" title="Link target outside of Sample"><i>About the Author</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?9ad2e484